(() => {
  const root = document.querySelector('.livana-landing');
  if (!root) return;

  const checkedPack = () => root.querySelector('input[name="lvl_product_bundle"]:checked');
  const checkedPlan = () => root.querySelector('input[name="lvl_product_plan"]:checked');

  const packInputs = root.querySelectorAll('input[name="lvl_product_bundle"]');
  const cartButtons = root.querySelectorAll('[data-lvl-cart-button]');
  const cartDrawer = document.querySelector('cart-drawer');
  const cartError = root.querySelector('[data-lvl-cart-error]');
  const priceStatus = root.querySelector('[data-lvl-price-status]');
  const planBar = root.querySelector('.lvl-product__subbar');
  const subscriptionGiftGroups = root.querySelectorAll('[data-lvl-subscription-gifts]');
  const btnNows = root.querySelectorAll('[data-lvl-cart-now]');
  const btnWass = root.querySelectorAll('[data-lvl-cart-was]');
  const stickyBarLabels = root.querySelectorAll('[data-lvl-stickybar-label]');
  const orderSavings = root.querySelector('[data-lvl-order-savings]');
  const orderSavingsText = root.querySelector('[data-lvl-order-savings-text]');
  let inProgress = false;
  let reviewRequired = false;

  const updateSavingsLabel = (label, savings) => {
    if (!(label instanceof HTMLElement)) return;
    const defaultLabel = label.dataset.lvlCtaLabel || '';
    label.textContent = savings ? `${defaultLabel} - ${savings}` : defaultLabel;
  };

  const updateOrderSavings = (amount) => {
    if (!(orderSavings instanceof HTMLElement) || !(orderSavingsText instanceof HTMLElement)) return;
    const template = orderSavings.dataset.lvlSavingsTemplate || "You're saving __AMOUNT__ on this order.";
    orderSavingsText.textContent = amount ? template.replace('__AMOUNT__', amount) : '';
    orderSavings.hidden = !amount;
  };

  const clearCartError = () => {
    if (!cartError) return;
    cartError.textContent = '';
    cartError.hidden = true;
  };

  const announceCartError = (message) => {
    if (!cartError) return;
    cartError.textContent = message;
    cartError.hidden = false;
  };

  cartButtons.forEach((button) => {
    const label = button.querySelector('.lvl-product__button-label');
    if (label?.textContent) button.dataset.lvlCartDefaultLabel = label.textContent.trim();
    if (cartDrawer) button.setAttribute('aria-haspopup', 'dialog');
  });

  const updatePackPrices = (subscribed) => {
    packInputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const pack = input.closest('.lvl-product__pack');
      const visiblePrice = pack?.querySelector('[data-lvl-unit-price]') || pack?.querySelector('.lvl-product__pack-price');
      const comparePrice = pack?.querySelector('.lvl-product__pack-compare');
      if (!visiblePrice || !(comparePrice instanceof HTMLElement) || !pack) return;
      const oneTimePrice = input.dataset.price || '';
      const subscriptionPrice = input.dataset.subPrice || '';
      const oneTimeComparePrice = input.dataset.comparePrice || '';
      const subscriptionComparePrice = input.dataset.subComparePrice || '';
      const comparison =
        subscribed && subscriptionPrice
          ? input.dataset.subUnitComparePrice || subscriptionComparePrice
          : input.dataset.unitComparePrice || oneTimeComparePrice;
      visiblePrice.textContent = subscribed && subscriptionPrice
        ? input.dataset.subUnitPrice || subscriptionPrice
        : input.dataset.unitPrice || oneTimePrice;
      comparePrice.textContent = comparison;
      comparePrice.hidden = !comparison;
      const save = pack.querySelector('.lvl-product__pack-save');
      if (save instanceof HTMLElement) {
        const saving = subscribed
          ? input.dataset.subSave || input.dataset.save || ''
          : input.dataset.save || '';
        save.textContent = saving;
        save.hidden = !saving;
      }
    });
  };

  const updateButton = (announcePrice = false) => {
    if (inProgress) return;
    const pack = checkedPack();
    if (!(pack instanceof HTMLInputElement)) return;
    const price = pack.dataset.price || '';
    if (!price) return;
    const subscribed = Boolean(checkedPlan()) && Boolean(pack.dataset.sellingPlanId);
    if (planBar instanceof HTMLElement) planBar.hidden = !pack.dataset.sellingPlanId;
    updatePackPrices(subscribed);
    const visiblePrice = subscribed ? pack.dataset.subPrice || price : price;
    const comparison = subscribed
      ? pack.dataset.subComparePrice || ''
      : pack.dataset.comparePrice || '';
    const savings = subscribed
      ? pack.dataset.subSave || pack.dataset.save || ''
      : pack.dataset.save || '';
    const savingsAmount = subscribed
      ? pack.dataset.subSaveAmount || pack.dataset.saveAmount || ''
      : pack.dataset.saveAmount || '';
    updateOrderSavings(savingsAmount);
    cartButtons.forEach((button) => {
      if (reviewRequired) return;
      const label = button.querySelector('.lvl-product__button-label');
      updateSavingsLabel(label, savings);
      if (label?.textContent) button.dataset.lvlCartDefaultLabel = label.textContent.trim();
    });
    stickyBarLabels.forEach((label) => {
      updateSavingsLabel(label, savings);
    });
    btnNows.forEach((el) => {
      el.textContent = visiblePrice;
    });
    btnWass.forEach((el) => {
      el.textContent = comparison;
      if (el instanceof HTMLElement) el.hidden = !comparison;
    });
    subscriptionGiftGroups.forEach((group) => {
      (group).hidden = false;
      group.querySelectorAll('.lvl-product__pack-bonus').forEach((gift) => {
        (gift).hidden = !subscribed && !gift.hasAttribute('data-lvl-always-gift');
      });
    });
    if (announcePrice && priceStatus) {
      const card = pack.closest('.lvl-product__pack');
      const packTitle = card?.querySelector('.lvl-product__pack-title')?.textContent?.trim() || 'Selected option';
      const visiblePrice = subscribed ? pack.dataset.subPrice || price : price;
      const purchaseType = checkedPlan() ? 'automatic refill price per delivery' : 'one-time purchase price';
      priceStatus.textContent = `${packTitle}: ${purchaseType} ${visiblePrice}`;
    }
  };

  root.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.name === 'lvl_product_bundle' || target.name === 'lvl_product_plan') {
      if (!inProgress && !reviewRequired) clearCartError();
      updateButton(true);
    }
  });
  updateButton();

  const bar = root.querySelector('[data-lvl-stickybar]');
  const heroButton = root.querySelector('.lvl-product .lvl-product__button');
  if (bar && heroButton) {
    const endSentinel = root.querySelector('[data-lvl-stickybar-end]');
    let frame = 0;
    const syncBar = () => {
      frame = 0;
      const show =
        heroButton.getBoundingClientRect().bottom < 0 &&
        (!endSentinel || endSentinel.getBoundingClientRect().top > window.innerHeight);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
    };
    const queueSync = () => {
      if (!frame) frame = window.requestAnimationFrame(syncBar);
    };
    window.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync, { passive: true });
    syncBar();
  }

  const addToCart = async (button) => {
    if (inProgress) return;
    if (reviewRequired) {
      window.LivanaCartRecovery.reload();
      return;
    }
    const pack = checkedPack();
    const variantId = pack instanceof HTMLInputElement ? pack.value : '';
    clearCartError();
    if (!variantId) {
      announceCartError('Choose an option before adding this product to your cart.');
      return;
    }

    const sellingPlan =
      checkedPlan() && pack instanceof HTMLInputElement ? pack.dataset.sellingPlanId : '';
    const item = ({
      id: Number(variantId),
      quantity: 1,
    });
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    const giftVariantIds = [...new Set([
      pack.dataset.alwaysGiftVariantIds || '',
      sellingPlan ? pack.dataset.giftVariantIds || '' : '',
    ]
      .join(',')
      .split(',')
      .map((id) => Number(id))
      .filter((id) => Number.isSafeInteger(id) && id > 0))];
    const giftItems = giftVariantIds.map((id) => ({
      id,
      quantity: 1,
      parent_id: Number(variantId),
      properties: {
        _livana_free_gift: 'true',
        _livana_parent_variant: variantId,
      },
    }));

    const sectionIds =
      cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
        ? cartDrawer.getSectionsToRender().map((section) => section.id)
        : [];
    const body = ({
      items: [item, ...giftItems],
    });
    if (sectionIds.length) {
      body.sections = sectionIds;
      body.sections_url = window.location.pathname;
      if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(button);
    }

    const addUrl = window.routes?.cart_add_url || '/cart/add.js';
    const controller = new AbortController();
    const activeButtons = [...cartButtons].filter((cartButton) => !cartButton.disabled);
    const offerControls = [...root.querySelectorAll('input[name="lvl_product_bundle"], input[name="lvl_product_plan"]')]
      .filter((input) => !input.disabled);
    inProgress = true;
    offerControls.forEach((input) => { input.disabled = true; });
    activeButtons.forEach((cartButton) => {
      cartButton.setAttribute('aria-busy', 'true');
      cartButton.disabled = true;
      const label = cartButton.querySelector('.lvl-product__button-label');
      if (label) label.textContent = 'Adding…';
    });

    let timer;
    try {
      const deadline = new Promise((_, reject) => {
        timer = setTimeout(() => {
          reject(new Error('Cart request timed out'));
          controller.abort();
        }, 15000);
      });
      const request = fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
        signal: controller.signal,
      }).then(async (res) => {
        const response = await res.json();
        if (
          !res.ok ||
          !response ||
          response.status ||
          !Array.isArray(response.items) ||
          !response.items.length ||
          response.items.some((item) => !item || !Number.isSafeInteger(item.id) || item.id <= 0)
        ) {
          throw new Error('Unable to confirm cart addition');
        }
        return response;
      });
      const response = await Promise.race([request, deadline]);

      // An accepted addition must never be retried because its drawer failed.
      try {
        if (cartDrawer && response.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
          return;
        }
      } catch {
        // Reload the current page and reopen the drawer when rendering fails.
      }
      window.LivanaCartRecovery.reload();
    } catch {
      // Shopify may have applied the request even when its response is unusable.
      reviewRequired = true;
      announceCartError(window.cartStrings?.addReview || "We couldn't confirm your cart update. Please review your cart before adding this item again.");
    } finally {
      clearTimeout(timer);
      inProgress = false;
      offerControls.forEach((input) => { input.disabled = false; });
      activeButtons.forEach((cartButton) => {
        cartButton.removeAttribute('aria-busy');
        cartButton.disabled = false;
        if (reviewRequired) cartButton.removeAttribute('aria-haspopup');
        const label = cartButton.querySelector('.lvl-product__button-label');
        if (label) label.textContent = reviewRequired
          ? window.cartStrings?.viewCart || 'View cart'
          : cartButton.dataset.lvlCartDefaultLabel || 'Add to cart';
      });
    }
  };

  root.addEventListener('click', (event) => {
    const button =
      event.target instanceof Element ? event.target.closest('[data-lvl-cart-button]') : null;
    if (button instanceof HTMLButtonElement && !button.disabled) addToCart(button);
  });

  root.addEventListener('click', (event) => {
    const scroller =
      event.target instanceof Element ? event.target.closest('[data-lvl-stickybar-scroll]') : null;
    if (!scroller) return;
    event.preventDefault();
    const target = root.querySelector('#lvl-buybox');
    if (!target) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    const selectedPack = target.querySelector('input[name="lvl_product_bundle"]:checked');
    if (selectedPack instanceof HTMLInputElement) selectedPack.focus({ preventScroll: true });
  });
})();
